import { render, staticRenderFns } from "./TagContent.vue?vue&type=template&id=4308730e&scoped=true"
import script from "./TagContent.vue?vue&type=script&lang=js"
export * from "./TagContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308730e",
  null
  
)

export default component.exports